import Phaser from 'phaser';
import { GAME_H, GAME_W } from '@/core/config';
import { SceneKeys } from '@/core/scenes/keys';

export type ShowcaseFactory = (scene: Phaser.Scene) => void;
/** Modules register `?showcase=<name>` entries here so critics can inspect them in isolation. */
export const SHOWCASES: Record<string, ShowcaseFactory> = {};

export class ShowcaseScene extends Phaser.Scene {
  private module = '';
  constructor() { super(SceneKeys.SHOWCASE); }
  init(data: { module?: string }): void { this.module = data.module ?? ''; }
  create(): void {
    const f = SHOWCASES[this.module];
    if (!f) {
      this.add.text(GAME_W / 2, GAME_H / 2, `未知 showcase：${this.module}\n可用：${Object.keys(SHOWCASES).join(', ') || '(无)'}`, { fontFamily: 'sans-serif', fontSize: '14px', color: '#fff', align: 'center' }).setOrigin(0.5);
    } else {
      f(this);
    }
    window.__GAME_READY__ = true;
    if (window.__nantian) window.__nantian.ready = true;
  }
}
